import { render, staticRenderFns } from "./TaskFreeSpeakingView.vue?vue&type=template&id=21915568&scoped=true&"
import script from "./TaskFreeSpeakingView.vue?vue&type=script&lang=ts&"
export * from "./TaskFreeSpeakingView.vue?vue&type=script&lang=ts&"
import style0 from "./TaskFreeSpeakingView.vue?vue&type=style&index=0&id=21915568&prod&lang=css&"
import style1 from "./TaskFreeSpeakingView.vue?vue&type=style&index=1&id=21915568&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21915568",
  null
  
)

export default component.exports